import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import Images from "../../../Helpers/Images";
import validations from "../../../Helpers/customValidation";
import hasError from "../../../Helpers/ErrorHelper";
import { Auth } from "../../../Contexts/AuthContext";
import secureHash from "../../../Helpers/secureHash";
import {
  Notification,
  Placeholder,
  Uploader,
  useToaster,
  Message,
  Loader,
} from "rsuite";
import { APIRequest, ApiUrl, authHeaders } from "../../../Helpers/ApiHelper";
import { BsCamera } from "react-icons/bs";
import CustomLoader from "../../../Components/comman/Loader/CustomLoader";

const Profile = () => {
  const toaster = useToaster();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [profileData, setProfileData] = useState();
  const [validationErrors, setValidationErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { auth, setAuth, setFavoriteCounts } = useContext(Auth);
  const [uploading, setUploading] = useState(false);
  const [fileInfo, setFileInfo] = useState(null);

  useEffect(() => {
    getProfileData();
  }, []);
  const fileUploadParams = {
    folder: auth?.userRole.toLowerCase(),
  };
  const previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };
  // get profile data
  const getProfileData = () => {
    let config = {
      url: ApiUrl.getBrandProfile,
      method: "GET",
      body: {},
    };

    APIRequest(
      config,
      (res) => {
        setProfileData(res?.data);
        setIsLoading(false);
      },
      (err) => {
        setIsLoading(false);
      }
    );
  };
  // update form data
  const updateProfileData = () => {
    const updatedformData = {
      ...profileData,
    };

    let config = {
      url: ApiUrl.updateBrandProfile,
      method: "POST",
      body: {
        ...updatedformData,
        secureHash: secureHash.generate(updatedformData),
      },
    };
    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        setIsLoading(false);
        localStorage.setItem("user", JSON.stringify(res.user));
        localStorage.setItem("favCounts", res?.total_favorite_counts);
        setFavoriteCounts(res?.total_favorite_counts);
        setAuth({
          ...auth,
          user: res.user,
        });
        toaster.push(
          <Notification type="success" header="Success">
            <Placeholder.Paragraph
              style={{ width: 100, color: "red" }}
              rows={0}
            />
            Profile updated successfully
          </Notification>,
          {
            placement: "topEnd",
          }
        );
      },
      (err) => {
        if (err?.response?.status === 422) {
          setValidationErrors(err?.response?.data?.errors);
        } else if (err.response.status === 401) {
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                style={{ width: 100, color: "red" }}
                rows={0}
              />{" "}
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topEnd",
            }
          );
        }
        setIsLoading(false);
      }
    );
  };
  const handleUpdateProfile = () => {
    updateProfileData();
  };
  // handle onchange
  const handleOnChange = (name, value) => {
    const updatedData = {
      ...profileData,
      [name]: value,
    };

    if (name === "phone") {
      if (!validations.isPositveIntegerNumber(value)) {
        return false;
      }
    } else if (name === "name" || name === "owner_name") {
      if (!validations.isAlphabet(value)) {
        return false;
      }
    }

    // hide validation errors on change
    const IsError = validationErrors?.find((v) => v.field === name);
    if (IsError !== undefined) {
      setValidationErrors(validationErrors?.filter((v) => v.field !== name));
    }
    setProfileData(updatedData);
  };
  return (
    <div className="brandAccount-wrapper">
      <h3 className="heading-title">Account Setting</h3>
      <section className="personal-contact-wrapper">
        <div className="top-box">
          <h3 className="sub-heading">Contact Info</h3>
        </div>
        <div className="detail-box box">
          <CustomLoader visible={isLoading} />
          <div className="account-profile-img-box">
            <Uploader
              fileListVisible={false}
              listType="picture"
              headers={authHeaders}
              data={fileUploadParams}
              action={ApiUrl.uploadLogo}
              onUpload={(file) => {
                setUploading(true);
                previewFile(file.blobFile, (value) => {
                  setFileInfo(value);
                });
              }}
              onSuccess={(response, file) => {
                setUploading(false);
                setProfileData({
                  ...profileData,
                  avatar_file: response?.file,
                });
                // toaster.push(
                //   <Message type="success" header="Success">
                //     Uploaded successfully
                //   </Message>
                // );
              }}
              onError={() => {
                setFileInfo(null);
                setUploading(false);
                toaster.push(
                  <Message type="error" header="Error">
                    Upload failed
                  </Message>
                );
              }}
            >
              <button style={{ width: 120, height: 120, marginTop: 0 }}>
                {uploading && <Loader backdrop center />}
                {fileInfo ? (
                  <img
                    alt="fileInfo"
                    src={fileInfo}
                    width="100%"
                    height="100%"
                  />
                ) : (
                  <img
                    alt="fileInfsso"
                    src={
                      profileData?.avatar ? profileData?.avatar : Images.defUser
                    }
                    width="100%"
                    height="100%"
                  />
                )}
                <div className="upload">
                  <BsCamera />
                </div>
              </button>
            </Uploader>
          </div>
          {console.log("profileData brand", profileData)}
          <Form>
            <Row className="mb-3">
              <Form.Group
                as={Col}
                md="6"
                className="position-relative firstName"
              >
                <Form.Label>First name</Form.Label>
                <Form.Control
                  type="text"
                  name="first_name"
                  value={profileData?.first_name}
                  onChange={(e) => {
                    handleOnChange("first_name", e.target.value);
                  }}
                />
                <Form.Control.Feedback tooltip>
                  Looks good!
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                controlId="validationFormik102"
                className="position-relative lastName"
              >
                <Form.Label>Last name</Form.Label>
                <Form.Control
                  type="text"
                  name="last_name"
                  value={profileData?.last_name}
                  onChange={(e) => {
                    handleOnChange("last_name", e.target.value);
                  }}
                />

                <Form.Control.Feedback tooltip>
                  Looks good!
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" className="mb-3">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={profileData?.email}
                  disabled={!!profileData?.email}
                  onChange={(e) => {
                    handleOnChange("email", e.target.value);
                  }}
                />

                {hasError(validationErrors, "email")}
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                className="phone"
                controlId="formBasicEmail"
              >
                <Form.Label>Phone No.</Form.Label>
                <PhoneInput
                  name="phone"
                  country={"in"}
                  value={profileData?.phone}
                  onChange={(phone, countryData) => {
                    handleOnChange("phone", phone);
                  }}
                />
                {/* <PhoneInput
                  name="phone"
                  country={"in"}
                  value={profileData?.phone}
                  onChange={(e) => {
                    handleOnChange("phone", e.target.value);
                  }}
                /> */}
              </Form.Group>
            </Row>
          </Form>
        </div>
      </section>
      {/* notifications preference */}
      <section className="preference-wrapper">
        <div className="top-box">
          <h3 className="sub-heading">Email Preferences</h3>
          {/* <Button>
            <PiNotePencilDuotone /> Edit
          </Button> */}
        </div>
        <div className="details box">
          <Form>
            <Form.Check
              type="switch"
              id="custom-switch"
              label="Search Tool Invites"
            />
            <Form.Check
              type="switch"
              label="Chat Notifications"
              id="custom-switch"
            />
          </Form>
        </div>
      </section>
      {/* brand info */}
      <section className="brand-info-wrapper">
        <div className="top-box">
          <h3 className="sub-heading">Brand Info</h3>
        </div>
        <div className="details box">
          <Form>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" className="companyName">
                <Form.Label>Company Name</Form.Label>

                <Form.Control
                  type="text"
                  name="company_name"
                  value={profileData?.company_name}
                  onChange={(e) => {
                    handleOnChange("company_name", e.target.value);
                  }}
                />
                <Form.Control.Feedback tooltip>
                  Looks good!
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                controlId="validationFormik102"
                className="position-relative"
              >
                <Form.Label>Company Website</Form.Label>
                <Form.Control
                  type="text"
                  name="company_website"
                  value={profileData?.company_website}
                  onChange={(e) => {
                    handleOnChange("company_website", e.target.value);
                  }}
                />

                <Form.Control.Feedback tooltip>
                  Looks good!
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="12" className="insta-handle">
                <Form.Label>Instagram Handle</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="@"
                  name="instagram_handle"
                  value={profileData?.instagram_handle}
                  onChange={(e) => {
                    handleOnChange("instagram_handle", e.target.value);
                  }}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="12" className="mb-3">
                <Form.Label>Brand Story</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder=""
                  rows={5}
                  value={profileData?.brand_story}
                  onChange={(e) => {
                    handleOnChange("brand_story", e.target.value);
                  }}
                />
              </Form.Group>
            </Row>
          </Form>
        </div>
      </section>
      <div className="update-box">
        <Button className="theme-btn" onClick={handleUpdateProfile}>
          Update
        </Button>
      </div>
      {/* <section className="subscription-wrapper">
        <div className="top-box">
          <h3 className="sub-heading">Subscription</h3>
          <Button className="plan-btn">View Plans</Button>
        </div>

        <div className="detail box">
          <img src={Images.noData} alt="no data" />
          <p>No Active Subscription</p>
        </div>
      </section> */}
      <section className="brand-member-section ">
        <div className="top-box">
          <h3 className="sub-heading">Brand Members</h3>
          <Button className="plan-btn" onClick={handleShow}>
            Invite
          </Button>
        </div>
        <div className="content box">
          <div className="top-box">
            <div className="left">
              <h6>NAME</h6>
            </div>
            <div className="right">
              <h6>EMAIL</h6>
            </div>
          </div>
          <div className="bottom-box">
            <div className="left">
              <p>{profileData?.owner_name}</p>
            </div>
            <div className="right">
              <a href="mailto:maans401@gmail.com">{profileData?.email}</a>
            </div>
          </div>
        </div>
      </section>
      {/* modal */}
      <Modal className="member-invite-modal" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Invite Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Invite a member of your team to be added as a user to your brand
            account.
          </p>
          <Form>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>First name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  onChange={(e) => {
                    handleOnChange("firstName", e.target.value);
                  }}
                />
                <Form.Control.Feedback tooltip>
                  Looks good!
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                controlId="validationFormik102"
                className="position-relative"
              >
                <Form.Label>Last name</Form.Label>
                <Form.Control type="text" name="lastName" />

                <Form.Control.Feedback tooltip>
                  Looks good!
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Form.Group
              as={Col}
              md="12"
              controlId="validationFormik102"
              className="position-relative"
            >
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" name="email" />
              <Form.Control.Feedback tooltip>Looks good!</Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} className="theme-btn">
            Add Member
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Profile;
